module.exports = __webpack_public_path__ + "img/bnb.ed68f6ed.png";